// extracted by mini-css-extract-plugin
export default {"header":"header__65ut+","logo":"logo__73any","title":"title__Su6dK","btn-to-app":"btn-to-app__HUEic","btnToApp":"btn-to-app__HUEic"};